<template>
    <div v-if="editSalesItem">
        <h1>Redigera objekt</h1>

        <p>
            <router-link :to="`/store/${storeId}/sales_item/${editSalesItem.id}`" class="button">Tillbaka</router-link>
        </p>

        <SalesItemForm :salesItem="editSalesItem" @submit="submit"/>
    </div>
    <p v-else class="app-loader">
        Laddar...
    </p>
</template>

<script>
import SalesItemForm from '../components/SalesItemForm.vue'

export default {
    name: 'salesItemEdit',
    components: {
        SalesItemForm
    },
    data: function () {
        return {
            storeId: null,
            itemId: null,
            editSalesItem: null
        }
    },
    computed: {
        store() {
            return this.$store.getters['traderaStores/getById'](this.storeId);
        },
        salesItem() {
            return this.$store.getters['salesItems/getById'](this.itemId);
        }
    },
    methods: {
        submit() {
            this.$store.dispatch('salesItems/update', this.editSalesItem)
                .then(() => {
                    this.$router.push(`/store/${this.storeId}/sales_item/${this.editSalesItem.id}`);
                })
            ;
        }
    },
    created() {
        this.$store.dispatch('traderaStores/getAll');
        this.storeId = parseInt(this.$route.params.store_id, 10);
        this.$store.dispatch('salesItems/getAll', this.storeId);
        this.itemId = parseInt(this.$route.params.id, 10);
    },
    watch: {
        '$route'(to) {
            this.storeId = parseInt(to.params.store_id, 10);
            this.itemId = parseInt(to.params.id, 10);
        },
        salesItem() {
            this.editSalesItem = {
                id: this.salesItem.id,
                name: this.salesItem.name,
                description: this.salesItem.description
            }
        }
    }
}
</script>
